
import apiRequest from "./apiRequest";

export const sh6RegisterApi = {

    fetchSh6Register: (accountId, token) => {
    return apiRequest(`/api/register/sh6?accountId=${accountId}`, 'GET', token);
  },
  
     addNewEmployeStock: (id, payload, token) => {
    return apiRequest(
      `/api/register/sh6/add-new/Employee-stock/${id}`,
      "POST",
      token,
      payload          // ← body is forwarded as-is to apiRequest
    );
  },

  // Submit MGT-1 form data
  submitSh6Form: (formData, accountId, token) => {
    return apiRequest(`/api/register/sh6?accountId=${accountId}`, 'POST', token, formData);
  },

 

  
};